import { render } from "./ImageMove.vue?vue&type=template&id=6215df96"
import script from "./ImageMove.vue?vue&type=script&lang=js"
export * from "./ImageMove.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__